import { render } from "./CadastrarCompraItens.vue?vue&type=template&id=364d21d4"
import script from "./CadastrarCompraItens.vue?vue&type=script&lang=js"
export * from "./CadastrarCompraItens.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__